import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ConfigService } from 'app/app-config.service';
import { DCarbonizeAppConfig } from 'app/@types/shared/app-config';
import { environment } from 'environments/environment';
import { CustomTranslateService } from '@services/common/custom-translate.service';
import { filter, Subscription } from 'rxjs';
import { ClientAppConfig } from 'app/@types/shared/app-config';

@Component({
    selector: 'app-authentication',
    templateUrl: './authentication.component.html',
    styleUrls: ['./authentication.component.scss'],
})
export class AuthenticationComponent implements OnInit, OnDestroy {
    public hasLanguageMenu: boolean;
    public config: DCarbonizeAppConfig;
    public selectedLocale: string;
    currentAppVersion: string = environment.appVersion;
    public src = 'assets/images/pages/auth/registerWaves.png';
    isRegister: boolean = false;
    private routerSubscription: Subscription;
    public mainColor: string;
    public client?: ClientAppConfig;

    constructor(
        private route: ActivatedRoute,
        public configService: ConfigService,
        private translateService: CustomTranslateService,
        private router: Router,
    ) {
        this.hasLanguageMenu = this.route.snapshot.firstChild?.data.haslanguageMenu;
        this.client = this.configService.getClient;
        this.mainColor = this.client?.mainColor ?? '#3B82F6';
    }

    ngOnInit() {
        this.config = this.configService.getConfig;
        this.route.queryParamMap.subscribe((paramsMaps) => {
            if (!paramsMaps.has('locale')) return;
            const locale = paramsMaps.get('locale')!;
            if (!this.translateService.langs.includes(locale)) return;
            this.translateService.use(locale);
        });
    }

    ngOnDestroy() {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }

    public sendEmail() {
        const mailTo = this.configService.getClient.support?.mailDcarbonize;
        const mail = `mailto:${mailTo}`;
        window.open(mail, 'emailWindow');
    }
}
